var _rect, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackFirdayLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 25,
    viewBox: "0 0 122 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 122,
    height: 21.7,
    rx: 7.77306,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_195_217170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9858 10.846C20.0908 10.469 20.7408 9.754 20.7408 8.597C20.7408 6.881 19.1418 6.4 17.2438 6.4H12.7588L11.1598 15.5H15.9048C18.2968 15.5 20.3898 15.058 20.3898 12.796C20.3898 11.821 19.8568 11.171 18.9858 10.846ZM15.2938 9.962L15.5538 8.454H16.5548C17.1008 8.454 17.5558 8.532 17.5558 9.065C17.5558 9.793 17.0878 9.962 16.3208 9.962H15.2938ZM14.6958 13.381L14.9688 11.821H16.2298C16.7628 11.821 17.2568 11.873 17.2568 12.471C17.2568 13.225 16.7628 13.381 15.9308 13.381H14.6958ZM27.8917 15.5L28.3597 12.874H24.2777L25.4217 6.4H22.2107L20.6117 15.5H27.8917ZM38.9296 15.5L37.4736 6.4H33.3396L28.6596 15.5H32.0786L32.7156 14.07H35.5366L35.6796 15.5H38.9296ZM34.2626 10.599C34.5096 10.027 34.7436 9.455 35.0556 8.714H35.0686C35.0946 9.364 35.1596 10.118 35.2116 10.599L35.3156 11.743H33.7556L34.2626 10.599ZM43.6763 15.721C46.1853 15.721 48.0573 14.603 48.9023 12.562L45.6263 11.756C45.3793 12.77 44.7813 13.316 43.8193 13.316C43.2993 13.316 42.9093 13.147 42.6883 12.822C42.5323 12.601 42.4543 12.328 42.4543 11.951C42.4543 11.054 42.7533 9.624 43.2343 9.104C43.5593 8.753 43.9363 8.584 44.5473 8.584C45.4833 8.584 45.8733 9.221 45.9643 10.196L49.2663 9.65C48.8893 7.284 47.0303 6.179 44.7163 6.179C41.0893 6.179 39.0873 8.402 39.0873 11.795C39.0873 14.382 40.8553 15.721 43.6763 15.721ZM56.1272 6.4L53.2932 9.169L53.7872 6.4H50.6802L49.0812 15.5H52.1882L52.6172 13.082L53.5402 12.263L55.0352 15.5H58.6232L55.9192 10.131L60.0922 6.4H56.1272Z",
    fill: "url(#paint0_linear_195_217170)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_195_217170)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.0797 15.5L64.6257 12.406H68.3307L68.7467 10.053H65.0417L65.2497 8.805H69.4227L69.8387 6.4H62.4677L60.8687 15.5H64.0797ZM77.9851 13.459C78.0891 12.523 77.7901 11.847 77.0491 11.509C78.1801 11.132 78.9211 10.378 78.9211 8.974C78.9211 7.089 77.4781 6.4 75.5021 6.4H70.7831L69.1841 15.5H72.3431L72.8761 12.51H73.7211C74.5791 12.51 74.8521 12.796 74.7481 13.654C74.6701 14.317 74.5921 14.954 74.8781 15.5H78.2451L78.2581 15.461C77.9201 14.876 77.9071 14.187 77.9851 13.459ZM73.2531 10.391L73.5651 8.584H74.4491C75.1511 8.584 75.5931 8.662 75.5931 9.325C75.5931 10.17 75.0601 10.391 74.1501 10.391H73.2531ZM82.234 15.5L83.833 6.4H80.622L79.023 15.5H82.234ZM87.9105 15.5C91.3945 15.5 93.5135 13.55 93.5135 10.378C93.5135 7.96 91.9925 6.4 89.0545 6.4H85.1415L83.5425 15.5H87.9105ZM87.9235 8.857H88.4565C89.1585 8.857 89.6265 8.948 89.8865 9.351C90.0295 9.585 90.1335 9.936 90.1335 10.378C90.1335 11.275 89.9515 12.016 89.5095 12.51C89.1455 12.939 88.5605 13.147 87.7935 13.147H87.1695L87.9235 8.857ZM102.76 15.5L101.304 6.4H97.1697L92.4897 15.5H95.9087L96.5457 14.07H99.3667L99.5097 15.5H102.76ZM98.0927 10.599C98.3397 10.027 98.5737 9.455 98.8857 8.714H98.8987C98.9247 9.364 98.9897 10.118 99.0417 10.599L99.1457 11.743H97.5857L98.0927 10.599ZM107.298 15.5L107.87 12.224L112.251 6.4H108.637L107.701 7.778C107.389 8.233 107.051 8.792 106.661 9.377C106.479 8.727 106.31 8.09 106.219 7.791L105.79 6.4H102.345L104.685 12.094L104.074 15.5H107.298Z",
    fill: "url(#paint1_linear_195_217170)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_195_217170",
    x: 6.92368,
    y: 6.17896,
    width: 57.4046,
    height: 18.0149,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.23648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.11824
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_195_217170"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_195_217170",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_195_217170",
    x: 56.6327,
    y: 6.3999,
    width: 59.8558,
    height: 17.5731,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.23648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.11824
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_195_217170"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_195_217170",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_195_217170",
    x1: -18.5,
    y1: 11,
    x2: 42.8492,
    y2: -2.77818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66974,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_195_217170",
    x1: 60.629,
    y1: 11.7895,
    x2: 149,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#DCFAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackFirdayLabel);
export default __webpack_public_path__ + "static/media/blackFirdayLabel.d28ac0a80ad3299e2bbaec1c0cf8aa08.svg";
export { ForwardRef as ReactComponent };